<template>
  <div class="cc-wedo-parcel-shop" @click.prevent.stop>
    <div class="cc-wedo-parcel-shop__header">
      <div class="cc-wedo-parcel-shop__title mb-2" v-if="wedoParcelShop.selected.id">{{ wedoParcelShop.selected.name }}</div>
      <button class="cc-button cc-button--delivery-branch btn btn-primary" @click.stop="openWidget">{{ deliveryBranchButtonName }}</button>
    </div>
    <div class="cc-wedo-parcel-shop__main" v-if="isWidgetVisible">
      <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
        <div class="cc-popup__content">
          <div class="cc-popup__header">
            <div class="cc-popup__title">{{ translations['Search for parcel shop'] }}</div>
          </div>
          <div class="cc-popup__main">
            <div class="cc-form-input">
              <label for="wedoParcelShop.search" class="cc-label cc-label--text">{{ translations['Postal code or city'] }}</label>
              <input id="wedoParcelShop.search" type="email" name="wedoParcelShop.search" class="cc-input cc-input--text" @keyup.enter="search" v-model="searchQuery">
            </div>
            <table class="cc-table" v-if="wedoParcelShop.result.length > 0">
              <thead class="cc-table__thead">
              <tr class="cc-table__tr">
                <th class="cc-table__th">
                  {{ translations['Parcel shop'] }}
                </th>
                <th class="cc-table__th">
                  {{ translations['Street'] }}
                </th>
                <th class="cc-table__th">
                  {{ translations['Controls'] }}
                </th>
              </tr>
              </thead>
              <tbody class="cc-table__tbody">
              <tr v-for="postOffice in wedoParcelShop.result" v-bind:key="postOffice.id" class="cc-table__tr">
                <td class="cc-table__td">
                  {{ postOffice.naz_prov }}
                </td>
                <td class="cc-table__td">
                  {{ postOffice.adresa }}
                </td>
                <td class="cc-table__td">
                  <button class="cc-button cc-button--select-post-office btn btn-primary btn-sm" :data-post-office-id="postOffice.id" :data-post-office-name="postOffice.naz_prov" @click.prevent.stop="selectBranch">{{ translations['Select branch'] }}</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="cc-popup__footer">
            <button class="cc-button cc-button--popup-cancel btn btn-secondary" @click.prevent.stop="closeWidget">{{ translations['Cancel'] }}</button>
            <button class="cc-button cc-button--popup-ok btn btn-success" @click.prevent.stop="search">{{ translations['Search'] }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="cc-wedo-parcel-shop__main--big" v-if="isBigWidgetVisible">
      <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': isBigWidgetVisible}" @mousedown.self.prevent.stop="closeWidget">
        <div class="cc-popup__content">
          <div class="cc-popup__main">
            <iframe id="wedo-parcelshop-map" class="mapa_iframe" :title="translations['Select parcel shop']" width="100%" height="800px" allow="geolocation" src="https://widget.wedo.cz/v5/widget-content?selectMode=postMessage"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      wedoParcelShop: state => state.wedoParcelShop,
    }),
    deliveryBranchButtonName: function () {
      return this.wedoParcelShop.selected.id ? this.translations['Change'] : this.translations['Select branch'];
    },
    isWidgetVisible: function () {
      if (this.carrier.extra.widget === true) {
        return false;
      }
      if (this.selectedCarrier === null) {
        return this.shouldWidgetBeShown;
      }
      if (this.selectedCarrier.module === 'shaim_ulozenka' && this.wedoParcelShop.selected.id === null) {
        return true;
      }

      return this.shouldWidgetBeShown;
    },
    isBigWidgetVisible: function () {
      if (this.carrier.extra.widget === false) {
        return false;
      }
      if (this.selectedCarrier === null) {
        return this.shouldWidgetBeShown;
      }
      if (this.selectedCarrier.module === 'shaim_ulozenka' && this.wedoParcelShop.selected.id === null) {
        return true;
      }

      return this.shouldWidgetBeShown;
    }
  },
  data: function () {
    return {
      shouldWidgetBeShown: false,
      searchQuery: '',
    };
  },
  methods: {
    openWidget: function () {
      this.$store.commit('SET_WEDO_PARCEL_SHOP_SEARCH', '');
      this.$store.commit('SET_WEDO_PARCEL_SHOP_POST_OFFICES', {});
      this.shouldWidgetBeShown = true;
    },
    closeWidget: function () {
      if (this.wedoParcelShop.selected.id === null) {
        this.$emit('closeWithoutParcelShop');
      }
      this.shouldWidgetBeShown = false;
    },
    search: function () {
      this.$store.commit('SET_WEDO_PARCEL_SHOP_SEARCH', this.searchQuery);
      this.$store.dispatch('LOAD_WEDO_PARCEL_SHOPS');
    },
    selectBranch: function (event) {
      this.$store.commit('SET_WEDO_PARCEL_SHOP_SELECTED_POST_OFFICE', {id: event.currentTarget.dataset.postOfficeId, name: event.currentTarget.dataset.postOfficeName});
      this.closeWidget();
      this.$store.commit('SET_WEDO_PARCEL_SHOP_SEARCH', '');
      this.$store.commit('SET_WEDO_PARCEL_SHOP_POST_OFFICES', {});
      this.$emit('selectCarrier', this.carrier)
    },
    iframeListener: function (event) {
      var id = event.data.selectedID;
      var full = event.data.selectedName;

      if (id) {
        this.$store.commit('SET_WEDO_PARCEL_SHOP_SELECTED_POST_OFFICE', {
          id: id,
          name: full
        });
        this.closeWidget();
        this.$emit('selectCarrier', this.carrier)
      }
    }
  },
  mounted() {
    if (this.carrier.extra.widget) {
      window.addEventListener("message", this.iframeListener);
    }
  },
  name: 'WedoParcelShop',
  props: [
    'carrier',
    'selectedCarrier',
  ],
};
</script>

<style lang="scss" scoped="scoped">
@import "./scss/components/wedo-parcel-shop";
</style>
